module.exports = require("npm:stream-browserify@1.0.0/index.js");